<template>
<v-row>
  <v-col cols="12" md="5">
    <search-box
        label="* Comprador"
        popup-label="Selecione um Comprador"
        :id.sync="value.idComprador"
        :nomeCompleto.sync="value.descricaoComprador"
        :hidden-clear="false"
        :value="comprador"
        :loader-fn="loadeComprador"
        item-key="id"
        item-text="nomeCompleto"
        :rules="[
            this.$validators.notNullOrUndefined
        ]">
      <template v-slot:empty>
        <p class="ma-2">
          Nenhum Comprador encontrado
        </p>
      </template>
    </search-box>
  </v-col>
  <v-col cols="12" sm="2">
    <lookup-dominio label="* Tipo Item"
                    :hidden-clear="true"
                    hint="Selecione o Tipo"
                    v-model="value.idTipoItemOferta"
                    :type="lookups.tipoItem"
                    />
  </v-col>  
  <v-col cols="12" md="5">
    <search-box ref="comboOfertas"
        label="* Item Demandado"
        popup-label="Selecione uma Demanda"
        :id.sync="value.idOferta"
        :descricao.sync="value.descricaoOferta"
        :hidden-clear="false"
        :value="oferta"
        :loader-fn="loadeOferta"
        item-key="id"
        item-text="descricao"
        :rules="[
            this.$validators.notNullOrUndefined
        ]">
      <template v-slot:empty>
        <p class="ma-2">
          Nenhuma Oferta encontrada
        </p>
      </template>
    </search-box>
  </v-col>
  <v-col cols="12" md="12">
    <v-textarea 
      dense
      rows="6"
      label="* Descrição da Demanda"
      :rules="[
          this.$validators.string.required,
          v => this.$validators.string.greaterThanOrEquals(v, 1),
          v => this.$validators.string.lessThanOrEquals(v, 4000),
      ]"
      v-model.trim="value.descricao"/>
  </v-col>
  <v-col cols="12" md="6">
    <v-text-field label="Data Expiração"
                  dense
                  type="date"
                  :rules="[
                      this.$validators.string.required,
                  ]"
                  v-model="value.dataExpiracao" />
  </v-col>
  <v-col cols="12" md="6">
    <lookup-dominio label="* Status"
                    :hidden-clear="false"
                    hint="Selecione o Status"
                    v-model="value.status"
                    :rules="[
                        this.$validators.string.required,
                    ]"
                    :type="lookups.status"
                    />
  </v-col>
  <v-col cols="12"> 
    <v-row align="center" justify="space-between" class="mb-4">
      <v-col cols="auto">
        <h4 class="mb-0">Selecione os estados para buscar os Fornecedores:</h4>
      </v-col>
      <v-col cols="auto">
        <v-btn small color="primary" class="mr-2" @click="selecionarTodos">
          Marcar todos
        </v-btn>
        <v-btn small color="success" @click="limparSelecao">
          Desmarcar todos
        </v-btn>    
      </v-col>
    </v-row>

    <v-container>
      <v-row>
        <v-col 
          cols="12"
          md="2"
          v-for="estado in comboEstados"
          :key="estado.sigla"
        >
          <v-checkbox
            v-model="value.estados"
            :label="`${estado.nome} (${estado.sigla})`"
            :value="estado.sigla"
            hide-details
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-container>      
  </v-col> 
</v-row>
</template>

<script>
import {ItemDeDominio} from "../../../api/itemsDominio";
import LookupDominio from "../common/LookupDominio";
import SearchBox from "../common/SearchBox";
import SearchBoxMultiple from "../common/SearchBoxMultiple";
//PKs
import {findAll as findAllComprador} from "../../../api/comprador";
import {findAll as findAllOferta} from "../../../api/oferta";

export default {
  name: "DemandaForm",
  components: {SearchBox, LookupDominio, SearchBoxMultiple},
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      lookups: {
        status: ItemDeDominio.STATUS_PADRAO,
        tipoItem: ItemDeDominio.TIPO_ITEM,
      },
      loading: false,
      error: null,
      comboEstados: [
        { sigla: 'AC', nome: 'Acre' },
        { sigla: 'AL', nome: 'Alagoas' },
        { sigla: 'AM', nome: 'Amazonas' },
        { sigla: 'AP', nome: 'Amapá' },
        { sigla: 'BA', nome: 'Bahia' },
        { sigla: 'CE', nome: 'Ceará' },
        { sigla: 'DF', nome: 'Distrito Federal' },
        { sigla: 'ES', nome: 'Espírito Santo' },
        { sigla: 'GO', nome: 'Goiás' },
        { sigla: 'MA', nome: 'Maranhão' },
        { sigla: 'MG', nome: 'Minas Gerais' },
        { sigla: 'MS', nome: 'Mato Grosso do Sul' },
        { sigla: 'MT', nome: 'Mato Grosso' },
        { sigla: 'PA', nome: 'Pará' },
        { sigla: 'PB', nome: 'Paraíba' },
        { sigla: 'PE', nome: 'Pernambuco' },
        { sigla: 'PI', nome: 'Piauí' },
        { sigla: 'PR', nome: 'Paraná' },
        { sigla: 'RJ', nome: 'Rio de Janeiro' },
        { sigla: 'RN', nome: 'Rio Grande do Norte' },
        { sigla: 'RO', nome: 'Rondônia' },
        { sigla: 'RR', nome: 'Roraima' },
        { sigla: 'RS', nome: 'Rio Grande do Sul' },
        { sigla: 'SC', nome: 'Santa Catarina' },
        { sigla: 'SE', nome: 'Sergipe' },
        { sigla: 'SP', nome: 'São Paulo' },
        { sigla: 'TO', nome: 'Tocantins' }
      ],
    }
  },
  computed: {
    comprador(){
      if (this.value.idComprador == null) return null;
      return {
        id: this.value.idComprador,
        nomeCompleto: this.value.descricaoComprador
      }      
    },
    oferta(){
      if (this.value.idOferta == null) return null;
      return {
        id: this.value.idOferta,
        descricao: this.value.descricaoOferta
      }      
    },
  },
  watch: {
    'value.idTipoItemOferta': {
      deep: true,
      handler(newValue, oldValue) {
        console.log('mudou tipo item oferta');
        if (newValue !== oldValue) {
          this.$refs.comboOfertas.resetValues();
          this.$refs.comboOfertas.search();
        }
      }
    },
  },
  methods: { 
    loadeComprador(page, search) {
      return findAllComprador(page, {
        nome: search
      })
    },
    loadeOferta(page, search) {
      return findAllOferta(page, {
        descricao: search,
        idTipoItem: this.value.idTipoItemOferta === '' ? '--' : this.value.idTipoItemOferta,
      })
    },
    selecionarTodos() {
      this.value.estados = this.comboEstados.map(estado => estado.sigla);
    },
    limparSelecao() {
      this.value.estados = [];
    }    
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.curso-chip {
  padding-right: 0;
  cursor: initial;
  background-color: rgba(0,0,0,0.1);
  height: 32px;
  border-radius: 16px;
  border: 1px solid #dedede;
  display: flex;
  justify-content: center;
  align-items: center;

  .item-description {
    min-width: 150px;
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-right: 5px;
  }
  .remove-button {
    height: 32px;
    cursor: pointer;
    background-color: rgba(0,0,0,0.2);
    border-left: 2px solid #dedede;
    padding: 5px 8px !important;
    transition: background-color 0.5s ease 0s;
    &:hover {
      background-color: rgba(0,0,0,0.3);
    }

  }

}
</style>